import React, { Component } from 'react'
import './_styles.scss'
import Asset from '../../../../../requests/apa/Asset.js'
import { 
  FINAL,
  SEMIFINAL,
  CUARTOS,
  OCTAVOS,
  DIECISEISAVOS,
  FASES_DE_GRUPOS  
} from '../../../constants.js'
/**
 * LateralTag
 * Sidebar pill with vertically rotated image (Figma: 88x544px)
 * Left side: rounded top-left + bottom-left corners
 * Right side: rounded top-right + bottom-right corners
 *
 * Props:
 *  - text    {string}          Phase label (e.g. "Final", "Dieciseisavos")
 *  - phaseId {string}          Phase id used to resolve the image asset slug
 *                              (e.g. 'final', 'semifinal', 'fase-de-grupos')
 *  - side    {'left'|'right'}  Which side of the panel it sits on
 */

// Maps phase id → asset slug (fase-de-grupos differs from the URL slug)
const ID_TO_SLUG = {
  [FINAL]: 'eventodeportivo_tabsetapas_imagen1_pestana6',
  [SEMIFINAL]: 'eventodeportivo_tabsetapas_imagen1_pestana5',
  [CUARTOS]: 'eventodeportivo_tabsetapas_imagen1_pestana4',
  [OCTAVOS]: 'eventodeportivo_tabsetapas_imagen1_pestana3',
  [DIECISEISAVOS]: 'eventodeportivo_tabsetapas_imagen1_pestana2',
  [FASES_DE_GRUPOS]: 'eventodeportivo_tabsetapas_imagen1_pestana1',
}

class LateralTag extends Component {

  getImageUrl(key, side) {
    if(side === 'right') {
      key = key.replace('imagen1', 'imagen2')
    }
    return Asset.get(key,'')
  }

  render () {
    const { text, phaseId, side } = this.props
    const isRight = side === 'right'
    const slug = ID_TO_SLUG[phaseId] || ''
    const imageUrl = slug ? this.getImageUrl(slug, side) : ''

    return (
      <div className={`lateral-tag lateral-tag--${isRight ? 'right' : 'left'}`}>
        {imageUrl
          ? <img className='lateral-tag__image' src={imageUrl} alt={text} />
          : (
            <div className='lateral-tag__text-wrapper'>
              <span className='lateral-tag__text'>{text}</span>
            </div>
          )
        }
      </div>
    )
  }
}

export default LateralTag



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/LateralTag/index.jsx